<template>
    <div v-if="visible" class="flex" style="width: 100%;height:90px"></div>

    <div v-if="visible" class="fixed xl:block lg:block md:block w-full px-3 z-10 bottom-0 min-h-3 surface-0 shadow-4">
        <div class="center flex w-full flex-column
            xl:px-4 lg:px-4 md:px-4">
            <div class="flex flex-row justify-content-between w-full mt-2 mb-2">

                <div @click="goTo('main')"
                    class="flex flex-column align-items-center justify-content-center mx-1">
                    <Button class="mb-1 border-none surface-0 text-xl" :disabled="false" rounded
                        :class="(isActive('/')) ? 'text-primary' : 'text-500'" >
                        <template #icon>
                            <span class="pi pi-send text-2xl"></span>
                        </template>
                    </Button>
                    <span class="text-500 font-medium" style="font-size:0.75rem">{{ menu[lang_].send }}</span>
                </div>

                <div v-if="isLoggedIn"  @click="goTo('vcards')"
                    class="flex flex-column align-items-center justify-content-center mx-1">
                    <Button class="mb-1 border-none surface-0" :disabled="false" rounded
                        :class="(isActive('/personal/vcards/')) ? 'text-primary' : 'text-500'" >
                        <template #icon>
                            <span class="pi pi-credit-card text-2xl"></span>
                        </template>
                    </Button>
                    <span class="text-500 font-medium" style="font-size:0.75rem">{{ menu[lang_].vcards }}</span>
                </div>

                <div v-if="isLoggedIn" @click="goTo('wallets')"
                    class="flex flex-column align-items-center justify-content-center mx-1">
                    <Button class="mb-1 border-none surface-0" :disabled="false" rounded
                        :class="(isActive('/personal/wallets/')) ? 'text-primary' : 'text-500'" >
                        <template #icon>
                            <span class="pi pi-wallet text-2xl"></span>
                        </template>
                    </Button>
                    <span class="text-500 font-medium" style="font-size:0.75rem">{{ menu[lang_].wallets }}</span>
                </div>

                <div v-if="isLoggedIn"  @click="goTo('products')"
                    class="flex flex-column align-items-center justify-content-center mx-1">
                    <Button class="mb-1 border-none surface-0" :disabled="false" rounded
                        :class="(isActive('/personal/products/')) ? 'text-primary' : 'text-500'" >
                        <template #icon>
                                <span class="pi pi-th-large text-2xl"></span>
                        </template>
                    </Button>
                    <span class="text-500 font-medium" style="font-size:0.75rem">{{ menu[lang_].products }}</span>
                </div>

            </div>
        </div>
        <div v-if="isPWA || isTgApp" class="w-hull surface-0" style="height:20px;"></div>
    </div>

    <ConfirmDialog></ConfirmDialog>

</template>


<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    props: ['loading'],
    data() {
        return {
            isLoading: false,
            tgUser: null,
            isTgApp: false,
            menu: {
                ru: {
                    send: 'Перевод',
                    transfers: 'Переводы',
                    bills: 'Счета',
                    support: 'Поддержка',
                    products: 'Продукты',
                    wallets: 'Кошелек',
                    chat: 'Чат',
                    profile: 'Профиль',
                    vcards: 'Карты',
                },
                en: {
                    send: 'Transfer',
                    transfers: 'Transfers',
                    bills: 'Bills',
                    support: 'Support',
                    products: 'Products',
                    wallets: 'Wallet',
                    chat: 'Chat',
                    profile: 'Profile',
                    vcards: 'Cards',
                }
            }
        }
    },
    props: ['loading'],
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        goTo(page) {
            try{
                window.scrollTo({ top: 0, behavior: 'smooth' })
            } catch {}
            try{
                window.Telegram.WebApp.HapticFeedback.impactOccurred('light')
            } catch {}

            if(!page) return
            if(page=='main') this.$router.push({path: '/'})
            if(page=='transfers') this.$router.push({path: '/personal/transfers/'})
            if(page=='bills') this.$router.push({path: '/personal/bills/'})
            if(page=='profile') this.$router.push({path: '/personal/profile/'})
            if(page=='chat') this.$router.push({path: '/chat/'})
            if(page=='products') this.$router.push({path: '/personal/products/'})
            if(page=='wallets') this.$router.push({path: '/personal/wallets/'})
            if(page=='auth') this.$router.push({path: '/auth/'})
            if(page=='support') this.$router.push({path: '/support/'})
            if(page=='vcards') this.$router.push({path: '/personal/vcards/'})
        },
        async logout() {
            await this.$store.dispatch('LogOut')
        },
        isActive(path) {
            return this.$router.currentRoute.value.fullPath == path
        },
    },
    watch: {

    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
        userPhoto: function () { return this.$store.getters.StateUserPhoto },
        userLetter: function () { return this.$store.getters.StateLetter },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        routeName: function () { return this.$router.currentRoute.value.name },
        visible: function () { 
            if(this.routeName == 'Transfer Details') return false
            return true
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        if(this.isTgApp) {
            const user = this.helper.getTgUserObject(this.initData)
            this.tgUser = user
        }
    }
}
</script>